import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

type GetContainerReleaseResponse = {
  state: number;
  value: string[];
};

export const getCitiesList = async (): Promise<string[]> => {
  try {
    const res = await apiClient.post<GetContainerReleaseResponse>(
      Endpoints.Cities,
      {}
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
